/**
 * Used for primitives options.
 *
 * @internal
 */
export const OPTIONS: unique symbol = Symbol.for("Alepha.Options");
